"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleHttpClientError = exports.getMeHttpClient = exports.getHttpClient = void 0;
const axios_1 = __importDefault(require("axios"));
const id_1 = require("../services/id");
const getHttpClient = (options = {}) => {
    return axios_1.default.create(Object.assign({ baseURL: `${(0, id_1.getAPIHost)()}/api`, timeout: 30 * 1000 }, options));
};
exports.getHttpClient = getHttpClient;
const getMeHttpClient = (options = {}) => {
    const { headers: headersOverride } = options, restOptions = __rest(options, ["headers"]);
    return axios_1.default.create(Object.assign({ baseURL: (0, id_1.getMEURL)(), timeout: 30 * 1000, headers: Object.assign({ authorization: `Bearer ${process.env.ADMIN_KEY}` }, headersOverride) }, restOptions));
};
exports.getMeHttpClient = getMeHttpClient;
/**
 * @example
 *    try {
 *      const res = await axios.get(path)
 *      return res.data
 *    } catch (err) {
 *      const [errStatus, errCode, originalErrMsg, value] = handleHttpClientError(err)
 *      return value;
 *    }
 *
 *  @returns tuple error status code, HttpClientErrorCode, original error message, response err msg string
 */
const handleHttpClientError = (err) => {
    var _a, _b, _c, _d, _e, _f, _g;
    if (axios_1.default.isAxiosError(err)) {
        const resStatus = (_a = err.response) === null || _a === void 0 ? void 0 : _a.status;
        const resMsg = (_g = (_d = (_c = (_b = err.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.msg) !== null && _d !== void 0 ? _d : (_f = (_e = err.response) === null || _e === void 0 ? void 0 : _e.data) === null || _f === void 0 ? void 0 : _f.message) !== null && _g !== void 0 ? _g : null;
        if (resStatus === 404) {
            return [404, 'notFound', err.message, resMsg];
        }
        if (resStatus === 400) {
            return [400, 'badRequest', err.message, resMsg];
        }
        if (resStatus === 401) {
            return [401, 'unauthorized', err.message, resMsg];
        }
        if (resStatus === 403) {
            return [403, 'forbiden', err.message, resMsg];
        }
        if (resStatus === 422) {
            return [422, 'unprocessableEntity', err.message, resMsg];
        }
        if (resStatus === 429) {
            return [429, 'tooManyRequests', err.message, resMsg];
        }
        if (resStatus === 500) {
            return [500, 'unknownError', err.message, resMsg];
        }
    }
    // won't handle other errors, rethrow
    return [null, 'unhandled', 'unhandled HTTP client error', null];
};
exports.handleHttpClientError = handleHttpClientError;
